var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service"},[_c('iframe',{attrs:{"src":_vm.url,"frameborder":"0","width":"100%","height":"700"}})])}
var staticRenderFns = []

export { render, staticRenderFns }